import { Injectable } from "@angular/core";
import { AppConfig } from "@mpt-fo/common/shared/config/app-config";
import { StorageKeys } from "@mpt-fo/common/shared/models/storage-keys";
import { UserAlias } from "@mpt-fo/common/shared/constants";
import { ApiClientHelper } from "../../helpers/api-client.helper";
import { LocalStorageService } from "../local-storage.service";
import { ErrorCode } from "../../models";
import { SelectAdaptor } from "@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component";
import { Cluster, ClusterApiPayload, ClusterListResponse, LoggedInClusterManagerResponse } from "@mpt-fo/common/shared/models/cluster-manager.model";

@Injectable({
	providedIn: 'root'
})
export class ClusterManagerManagementService {
	public tokenDataDeviceResponse;

	constructor(
		private apiClientHelper: ApiClientHelper,
		private localStorage: LocalStorageService,
		public config: AppConfig,
	) {}

    saveClusterManagerRefreshTokenToStorage(refreshToken) {
        this.localStorage.save(StorageKeys.CLUSTER_MANAGER_REFRESH_TOKEN, JSON.stringify(refreshToken));
    }

    assignBrm({ clusterName, brmCodes }: { brmCodes: string; clusterName: string }) {
        let url = `${this.config.MONIEPOINT_HOST}/api/v1/clusters/${clusterName}/assign-brms`;
        const body: { clusterCode?: string; brmCodes: Array<string>; } = { brmCodes : [brmCodes] };
        if (this.config.USE_UPDATED_CLUSTER_ASSIGNMENT_URL) {
            url = `${this.config.MONIEPOINT_HOST}/api/v1/clusters/assign-brms`;
            body.clusterCode = clusterName;
        }
        return this.apiClientHelper.putForPromise(url, body);
    }

    isNewClusterManagerLogin() {
        return this.localStorage.get(StorageKeys.CLUSTER_MANAGER_REFRESH_TOKEN);
    }

    deleteClusterManagerUserRefreshTokenFlowData() {
        this.localStorage.deleteValue(StorageKeys.token);
        this.localStorage.deleteValue(StorageKeys.moniepointAgentId);
        this.localStorage.deleteValue(StorageKeys.CLUSTER_MANAGER_REFRESH_TOKEN);
        this.tokenDataDeviceResponse = null;
    }

    isClusterManagerUser(err) {
        const error = err?.error;
        const roles = error?.tokenDataDeviceResponse?.tokenData?.roles ?? [];
        return error?.code === ErrorCode.CLUSTER_MANAGER_USER_LOGIN || (roles.length == 2 && roles.includes(UserAlias.clusterManager));
    }

    isClusterManager() {
        return this.localStorage.getUserRole() === UserAlias.clusterManager;
    }

	getClusters(params: Readonly<ClusterApiPayload>): Promise<ClusterListResponse> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/clusters`;
		return this.apiClientHelper.getForPromise(url, true, true, false, {}, params);
	}

    getClusterForLoggedInClusterManager(): Promise<LoggedInClusterManagerResponse> {
		const url = `${this.config.MONIEPOINT_OFFLINE_SALES_URL}/partner-management/api/v1/cluster-manager`;
		return this.apiClientHelper.getForPromise(url);
    }

    async getClustersAdaptor() {
		let clusters: Cluster[];
        if (this.isClusterManager()) {
            const clustersResponse = await this.getClusterForLoggedInClusterManager();
            clusters = [clustersResponse.responseBody];
        } else {
            // Current limit to clusters under an SC is 25. The page size is set to 100 assuming the limit won't exceed 100 in near future.
            const clustersResponse = await this.getClusters({ pageNumber: 1, pageSize: 100 });
            clusters = clustersResponse.content;
        }
        const selectAdaptor: SelectAdaptor[] = [];
        clusters.forEach((e) => {
            const label = e.name;
            const value = e.code;
            selectAdaptor.push({ label, value });
        });
        return selectAdaptor;
    }

    async switchClusterManagerRole(role: string) {
        const refreshToken = JSON.parse(this.localStorage.get(StorageKeys.CLUSTER_MANAGER_REFRESH_TOKEN));
        const url = `${this.config.MONIEPOINT_USER_URL}/api/v1/auth/partners/token`;
        const formData = new FormData();
        formData.append('role', role);
        const checkAuth = !this.config.REMOVE_CHECK_AUTH_FOR_CM;
        const res = await this.apiClientHelper.postForPromiseMultipart(url, formData, checkAuth, false, 'WEB', { RefreshToken: refreshToken });
        return res;
    }
}
